import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface StaticPageLayoutProps {
  titleKey?: string;
  subtitleKey?: string;
  title?: string;
  subtitle?: string;
  lastUpdatedKey?: string;
  date?: string;
  children: React.ReactNode;
}

export function StaticPageLayout({
  titleKey,
  subtitleKey,
  title,
  subtitle,
  lastUpdatedKey,
  date,
  children,
}: StaticPageLayoutProps) {
  const { t } = useTranslation();
  const heading = title ?? (titleKey ? t(titleKey) : '');
  const lead = subtitle ?? (subtitleKey ? t(subtitleKey) : '');

  return (
    <article className="dx-static-page">
      <div className="dx-static-page__inner">
        <Link to="/" className="dx-static-page__back">
          <svg className="w-4 h-4 rtl:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {t('staticPages.backToHome')}
        </Link>

        <header className="dx-static-page__hero">
          <p className="dx-static-page__eyebrow">Rocket Proxy</p>
          <h1>{heading}</h1>
          <p className="dx-static-page__subtitle">{lead}</p>
          {lastUpdatedKey && date && (
            <p className="dx-static-page__updated">
              {t(lastUpdatedKey)}: {date}
            </p>
          )}
        </header>

        <div className="dx-static-page__card">{children}</div>
      </div>
    </article>
  );
}
